var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"filterable":"","placeholder":"请选择","clearable":""},on:{"change":_vm.changeval},model:{value:(_vm.curvalue),callback:function ($$v) {_vm.curvalue=$$v},expression:"curvalue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }